"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlsForDataServiceId = exports.requestRedstonePayload = exports.requestDataPackages = exports.getDecimalsForDataFeedId = exports.parseDataPackagesResponse = exports.getDataServiceIdForSigner = exports.getOracleRegistryState = void 0;
const axios_1 = __importDefault(require("axios"));
const ethers_1 = require("ethers");
const redstone_oracles_smartweave_contracts_1 = require("redstone-oracles-smartweave-contracts");
const redstone_protocol_1 = require("redstone-protocol");
const redstone_utils_1 = require("redstone-utils");
const data_services_urls_1 = require("./data-services-urls");
const ALL_FEEDS_KEY = "___ALL_FEEDS___";
const DEFAULT_DECIMALS = 8;
const getOracleRegistryState = async () => {
    return redstone_oracles_smartweave_contracts_1.redstoneOraclesInitialState;
};
exports.getOracleRegistryState = getOracleRegistryState;
const getDataServiceIdForSigner = (oracleState, signerAddress) => {
    for (const nodeDetails of Object.values(oracleState.nodes)) {
        if (nodeDetails.evmAddress.toLowerCase() === signerAddress.toLowerCase()) {
            return nodeDetails.dataServiceId;
        }
    }
    throw new Error(`Data service not found for ${signerAddress}`);
};
exports.getDataServiceIdForSigner = getDataServiceIdForSigner;
const parseDataPackagesResponse = (dpResponse, reqParams) => {
    var _a;
    const parsedResponse = {};
    const requestedDataFeedIds = (_a = reqParams.dataFeeds) !== null && _a !== void 0 ? _a : [ALL_FEEDS_KEY];
    for (const dataFeedId of requestedDataFeedIds) {
        const dataFeedPackages = dpResponse[dataFeedId];
        if (!dataFeedPackages) {
            throw new Error(`Requested data feed id is not included in response: ${dataFeedId}`);
        }
        if (dataFeedPackages.length < reqParams.uniqueSignersCount) {
            throw new Error(`Too few unique signers for the data feed: ${dataFeedId}. ` +
                `Expected: ${reqParams.uniqueSignersCount}. ` +
                `Received: ${dataFeedPackages.length}`);
        }
        const dataFeedPackagesSorted = getDataPackagesSortedByDeviation(dataFeedPackages, reqParams.valuesToCompare, dataFeedId);
        parsedResponse[dataFeedId] = dataFeedPackagesSorted
            .slice(0, reqParams.uniqueSignersCount)
            .map((dataPackage) => redstone_protocol_1.SignedDataPackage.fromObj(dataPackage));
    }
    return parsedResponse;
};
exports.parseDataPackagesResponse = parseDataPackagesResponse;
const getDataPackagesSortedByDeviation = (dataFeedPackages, valuesToCompare, dataFeedId) => {
    var _a;
    if (!valuesToCompare) {
        return dataFeedPackages;
    }
    if (dataFeedId === ALL_FEEDS_KEY) {
        throw new Error(`Cannot sort data packages by deviation for ${ALL_FEEDS_KEY}`);
    }
    if (!valuesToCompare[dataFeedId]) {
        return dataFeedPackages;
    }
    const decimals = (_a = (0, exports.getDecimalsForDataFeedId)(dataFeedPackages)) !== null && _a !== void 0 ? _a : DEFAULT_DECIMALS;
    const valueToCompare = Number(ethers_1.utils.formatUnits(valuesToCompare[dataFeedId], decimals));
    return sortDataPackagesByDeviationDesc(dataFeedPackages, valueToCompare);
};
const getDecimalsForDataFeedId = (dataPackages) => {
    const firstDecimal = dataPackages[0].dataPoints[0]
        .decimals;
    const areAllDecimalsEqual = dataPackages.every((dataPackage) => dataPackage.dataPoints.every((dataPoint) => dataPoint.decimals === firstDecimal));
    if (!areAllDecimalsEqual) {
        throw new Error("Decimals from data points in data packages are not equal");
    }
    return firstDecimal;
};
exports.getDecimalsForDataFeedId = getDecimalsForDataFeedId;
const errToString = (e) => {
    if (e instanceof AggregateError) {
        const stringifiedErrors = e.errors.reduce((prev, oneOfErrors, curIndex) => (prev += `${curIndex}: ${oneOfErrors.message}, `), "");
        return `${e.message}: ${stringifiedErrors}`;
    }
    else {
        return e.message;
    }
};
const requestDataPackages = async (reqParams) => {
    const promises = prepareDataPackagePromises(reqParams);
    try {
        return await Promise.any(promises);
    }
    catch (e) {
        const errMessage = `Request failed ${JSON.stringify({
            reqParams,
        })}, Original error: ${errToString(e)}`;
        throw new Error(errMessage);
    }
};
exports.requestDataPackages = requestDataPackages;
const prepareDataPackagePromises = (reqParams) => {
    const urls = (0, exports.getUrlsForDataServiceId)(reqParams);
    const pathComponents = [
        "data-packages",
        reqParams.historicalTimestamp ? "historical" : "latest",
        reqParams.dataServiceId,
    ];
    if (reqParams.historicalTimestamp) {
        pathComponents.push(`${reqParams.historicalTimestamp}`);
    }
    return urls.map((url) => axios_1.default
        .get([url].concat(pathComponents).join("/"))
        .then((response) => (0, exports.parseDataPackagesResponse)(response.data, reqParams)));
};
const requestRedstonePayload = async (reqParams, unsignedMetadataMsg) => {
    const signedDataPackagesResponse = await (0, exports.requestDataPackages)(reqParams);
    const signedDataPackages = Object.values(signedDataPackagesResponse).flat();
    return redstone_protocol_1.RedstonePayload.prepare(signedDataPackages, unsignedMetadataMsg || "");
};
exports.requestRedstonePayload = requestRedstonePayload;
const getUrlsForDataServiceId = (reqParams) => {
    if (reqParams.urls) {
        return reqParams.urls;
    }
    return (0, data_services_urls_1.resolveDataServiceUrls)(reqParams.dataServiceId);
};
exports.getUrlsForDataServiceId = getUrlsForDataServiceId;
const sortDataPackagesByDeviationDesc = (dataPackages, valueToCompare) => dataPackages.sort((leftDataPackage, rightDataPackage) => {
    const leftValue = redstone_utils_1.SafeNumber.createSafeNumber(leftDataPackage.dataPoints[0].value);
    const leftValueDeviation = redstone_utils_1.SafeNumber.calculateDeviationPercent({
        currValue: leftValue,
        prevValue: redstone_utils_1.SafeNumber.createSafeNumber(valueToCompare),
    });
    const rightValue = redstone_utils_1.SafeNumber.createSafeNumber(rightDataPackage.dataPoints[0].value);
    const rightValueDeviation = redstone_utils_1.SafeNumber.calculateDeviationPercent({
        currValue: rightValue,
        prevValue: redstone_utils_1.SafeNumber.createSafeNumber(valueToCompare),
    });
    return rightValueDeviation.sub(leftValueDeviation).unsafeToNumber();
});
exports.default = {
    getOracleRegistryState: exports.getOracleRegistryState,
    requestDataPackages: exports.requestDataPackages,
    getDataServiceIdForSigner: exports.getDataServiceIdForSigner,
    requestRedstonePayload: exports.requestRedstonePayload,
    resolveDataServiceUrls: data_services_urls_1.resolveDataServiceUrls,
    getDecimalsForDataFeedId: exports.getDecimalsForDataFeedId,
};
__exportStar(require("./data-services-urls"), exports);
__exportStar(require("./contracts/ContractParamsProvider"), exports);
__exportStar(require("./contracts/IContractConnector"), exports);
__exportStar(require("./contracts/prices/IPricesContractAdapter"), exports);
//# sourceMappingURL=index.js.map